import { render } from "./branchOrgAddModal.vue?vue&type=template&id=d27c9c9c&ts=true"
import script from "./branchOrgAddModal.vue?vue&type=script&lang=ts"
export * from "./branchOrgAddModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__